import React, { useState, useEffect, useRef } from "react";
import { ThreeDots } from "react-loader-spinner";
import "../../Pages/Admin/Style.css";
import "../../Pages/Admin/Style.css";
import { BsStarFill, BsStar } from "react-icons/bs";
import "../../Api/apiUrls.js";
import { addCustomerReview } from "../../Api/apiUrls";
function Add_review({ onClose, id }) {
  console.log(id);
  const [modalAdd_reviewIsOpen, setAdd_reviewModalIsOpen] = useState("");
  const [rating, setRating] = useState("");
  const [review, setReview] = useState("");
  const [tittle, setTittle] = useState("");

  const [isAddingreview, setIsAddingreview] = useState(false);
  const handleStarClick = (section, selectedRating) => {
    switch (section) {
      case "rating":
        if (selectedRating === rating) {
          // If the same star is clicked again, reset to half-star (0.5)
          setRating(selectedRating - 0.5);
        } else {
          setRating(selectedRating);
        }
        console.log(selectedRating);
        break;
    }
  };
  const closeAdd_review = () => {
    setAdd_reviewModalIsOpen(false);
  };

  function reloadPage() {
    window.location.reload();
  }
  function reloadPage() {
    window.location.reload();
  }

  const handleClick = (e) => {
    if (e.currentTarget === e.target) {
      onClose();
      reloadPage();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [handleClick]);
  async function add_review(tittle, review, rating, id) {
    try {
      const formData = new FormData();
      formData.append("title", tittle);
      formData.append("review", review);
      formData.append("rating", rating);
      formData.append("appointment_id", id);

      const response = await fetch(addCustomerReview, {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        return true; // Category added successfully
      } else {
        throw new Error("Failed to add review rating");
      }
    } catch (error) {
      console.error("Error adding review rating:", error);
      return false; // Category addition failed
    }
  }

  const handleAdd_review = async () => {
    setIsAddingreview(true);

    const result = await add_review(tittle, review, rating, id);

    setIsAddingreview(false);

    if (result) {
      alert("Review Rating Added Successfully");
      console.log(setRating);
      setRating("");
      // window.location.reload();
      // setIconFile(null);
      // onClose(); // Close the modal
    } else {
      alert("Error Adding Review Rating");
    }
  };

  function reloadPage() {
    window.location.reload();
  }

  return (
    <div>
      {modalAdd_reviewIsOpen && <Add_review onClose={closeAdd_review} />}
      <div className="popup-background" onClick={handleClick}>
        <div className="popup">
          <div
            class="modal-content"
            style={{
              width: "75%",
              height: "auto",
              padding: "2%",
              backgroundColor: "#fff",
              borderRadius: "5px",
            }}
          >
            <div
              class="modal-header"
              style={{
                width: "100%",
                marginBottom: "3%",
                borderBottom: "solid 1px #7e7a7a8c",
              }}
            >
              <h5
                class="modal-title"
                id="modalAddTitle"
                style={{ marginBottom: "2%" }}
              >
                <b>Add Review</b>
              </h5>

              <button
                type="button"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div
              class="modal-body"
              style={{ overflowY: "none", padding: "2%" }}
            >
              <form>
                {/* <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Title
                  </label>
                  <input
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    value={tittle}
                    onChange={(e) => setTittle(e.target.value)}
                  />
                </div> */}
                <div class="form-group">
                  <label class="small mb-1" for="inputFullName">
                    Review
                  </label>
                  <textarea
                    class="form-control"
                    id="inputFullName"
                    type="text"
                    value={review}
                    onChange={(e) => setReview(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputUsername">
                    Rating
                    <font color="red"></font>
                  </label>
                  <br />
                  <div className="rating-stars">
                    {[1, 2, 3, 4, 5].map((index) => (
                      <span
                        key={index}
                        className="star-icon"
                        onClick={() => handleStarClick("rating", index)}
                      >
                        {rating >= index ? (
                          <BsStarFill
                            style={{
                              fontSize: "14px",
                              color: "gold",
                            }}
                          />
                        ) : (
                          <BsStar
                            style={{
                              fontSize: "14px",
                              color: "gray",
                            }}
                          />
                        )}
                      </span>
                    ))}
                  </div>
                </div>
              </form>
            </div>

            <div
              class="modal-footer"
              style={{
                padding: "2%",
                marginTop: "3%",
                borderTop: "solid 1px #7e7a7a8c",
              }}
            >
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                onClick={() => {
                  onClose();
                  reloadPage();
                }}
              >
                Close
              </button>
              {isAddingreview === true ? (
                <div>
                  <ThreeDots color="#000" height={50} width={50} />
                </div>
              ) : (
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary "
                  style={{ background: "#000 ", border: "none" }}
                  onClick={handleAdd_review}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Add_review;
